import { axiosInstance as request } from '@api/rest.service'

const api = '/fte-fields'

/**
 * @description GET /fte-fields
 * @returns {AxiosPromise<any>}
 */
export const GET_FTE_FIELDS = () => request.get(api)

/**
 * @description POST /fte-fields
 * @returns {AxiosPromise<any>}
 */
export const CREATE_FTE_FIELD = payload => request.post(api, payload)

/**
 * @description PATCH /fte-fields/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_FTE_FIELD = (id, payload) => request.patch(`${api}/${id}`, payload)

/**
 * @description GET /fte-fields/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_FTE_FIELD_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /fte-fields/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_FTE_FIELD = id => request.delete(`${api}/${id}`)
